export default __webpack_public_path__ + "img/pin_icons/key_w.png";